import { Component } from '@angular/core';

import { TableCellState } from '../../table.state';

@Component({
  selector: 'app-cell-user-basic',
  templateUrl: './cell-user-basic.component.html',
  styleUrls: ['./cell-user-basic.component.scss'],
})
export class CellUserBasicComponent extends TableCellState {}
